module.exports = __webpack_public_path__ + "static/img/manual_zh_4.b71613a.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/zh/manual_zh_4.png
// module id = XGIv
// module chunks = 4